import React from "react";

function formatINR(v) {
  return `₹${Number(v || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;
}

function Tile({ label, value, accent }) {
  return (
    <div>
      <div className="text-[10px] font-semibold uppercase tracking-[0.2em] text-slate-500">
        {label}
      </div>
      <div className={`mt-1.5 font-heading text-xl font-bold ${accent || "text-slate-900"}`}>
        {value}
      </div>
    </div>
  );
}

export default function VendorFinancialSummary({ vendor }) {
  const quote = Number(vendor.bank_quotation_value || 0);
  const actual = Number(vendor.actual_value || 0);
  const paid = Number(vendor.total_payments || 0);
  const bal = actual - paid;
  const pct = actual > 0 ? Math.min(100, Math.round((paid / actual) * 100)) : null;
  const barCls = pct >= 100 ? "bg-emerald-500" : pct >= 50 ? "bg-blue-500" : "bg-amber-500";
  const chipCls =
    pct >= 100
      ? "bg-emerald-50 text-emerald-700"
      : pct >= 50
      ? "bg-blue-50 text-blue-700"
      : "bg-amber-50 text-amber-700";

  return (
    <div
      className="bg-white border border-slate-200 rounded-lg p-6"
      data-testid="vendor-financial-summary"
    >
      <div className="flex items-center justify-between mb-5">
        <div className="text-[10px] font-semibold uppercase tracking-[0.2em] text-slate-500">
          Financial Summary
        </div>
        {pct !== null && (
          <span className={`text-xs font-bold px-2 py-0.5 rounded-full ${chipCls}`}>
            {pct}% settled
          </span>
        )}
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-5">
        <Tile label="Bank Quote" value={formatINR(quote)} />
        <Tile label="Actual Value" value={formatINR(actual)} />
        <Tile label="Payments" value={formatINR(paid)} accent="text-emerald-700" />
        <Tile
          label={bal > 0 ? "Balance Due" : "Balance"}
          value={formatINR(bal)}
          accent={bal > 0 ? "text-amber-700" : "text-slate-500"}
        />
      </div>
      {actual > 0 && (
        <div className="mt-5">
          <div className="h-2 w-full bg-slate-100 rounded-full overflow-hidden">
            <div
              className={`h-full rounded-full transition-all ${barCls}`}
              style={{ width: `${pct}%` }}
            />
          </div>
          <div className="mt-1.5 flex items-center justify-between text-[11px] text-slate-500">
            <span>{formatINR(paid)} received</span>
            <span>{bal > 0 ? `${formatINR(bal)} pending` : "Fully settled"}</span>
          </div>
        </div>
      )}
    </div>
  );
}
